export default {
  back: '\ue697',
  more: '\ue6a7',
  less: '\ue6a5',
  down: '\ue6a6',
  cart: '\ue698',
  category: '\ue699',
  close: '\ue69a',
  comments: '\ue69b',
  cry: '\ue69c',
  delete: '\ue69d',
  edit: '\ue69e',
  form: '\ue6a2',
  information: '\ue6a4',
  pic: '\ue6a8',
  qrcode: '\ue6a9',
  refresh: '\ue6aa',
  RFQ: '\ue6ab',
  search: '\ue6ac',
  selected: '\ue6ad',
  set: '\ue6ae',
  smile: '\ue6af',
  success: '\ue6b1',
  survey: '\ue6b2',
  training: '\ue6b3',
  gallery: '\ue6b4',
  list: '\ue6b5',
  warning: '\ue6b6',
  account: '\ue6b8',
  add: '\ue6b9',
  clock: '\ue6bb',
  remind: '\ue6bc',
  calendar: '\ue6bf',
  attachment: '\ue6c0',
  discount: '\ue6c5',
  service: '\ue6c7',
  print: '\ue6c9',
  box: '\ue6cb',
  process: '\ue6ce',
  electrical: '\ue6d4',
  home: '\ue6d7',
  electronics: '\ue6da',
  gift: '\ue6db',
  light: '\ue6de',
  sport: '\ue6e0',
  toy: '\ue6e1',
  auto: '\ue6e3',
  jewelry: '\ue6e4',
  'trade-assurance': '\ue6e5',
  browse: '\ue6e6',
  rfq: '\ue6eb',
  scanning: '\ue6ec',
  filter: '\ue6f1',
  history: '\ue6f3',
  'product-features': '\ue6f4',
  link: '\ue6f7',
  cut: '\ue6f8',
  'nav-list': '\ue6fa',
  'image-text': '\ue6fb',
  text: '\ue6fc',
  move: '\ue6fd',
  subtract: '\ue6fe',
  dollar: '\ue702',
  raw: '\ue704',
  office: '\ue705',
  agriculture: '\ue707',
  badge: '\ue70a',
  'person-center': '\ue70b',
  integral: '\ue70c',
  remind: '\ue713',
  download: '\ue714',
  map: '\ue715',
  skip: '\ue718',
  play: '\ue719',
  stop: '\ue71a',
  compass: '\ue71b',
  security: '\ue71c',
  share: '\ue71d',
  'manage-order': '\ue723',
  'rejected-oder': '\ue724',
  phone: '\ue725',
  'business-man': '\ue726',
  'mobie-phone': '\ue72a',
  excel: '\ue73f',
  pdf: '\ue740',
  zip: '\ue741',
  copy: '\ue744',
  copy: '\ue744',
  save: '\ue747',
  libra: '\ue74c',
  survey: '\ue74e',
  'bussiness-card': '\ue753',
  hot: '\ue756',
  data: '\ue757',
  'sign-board': '\ue75c',
  heart: '\ue7ce',
  'original-image': '\ue806',
  logistic: '\ue811',
  calculator: '\ue812',
  video: '\ue820',
  earth: '\ue828',
  'task-management': '\ue829',
  trust: '\ue82a',
  password: '\ue82b',
  cloumn3: '\ue839',
  cloumn4: '\ue83d',
  bag: '\ue83b',
  code: '\ue842',
  camera: '\ue86e',
  'add-account': '\ue87c',
  warehouse: '\ue87e',
  customization: '\ue87f',
  'electrical-equipment': '\ue884',
  'home-apply': '\ue885',
  inspection: '\ue880',
  furniture: '\ue886',
  bad: '\ue716',
  good: '\ue717',
  'good-filling': '\ue866',
  pin: '\ue6f2',
  'pin-filling': '\ue87a',
  help: '\ue6a3',
  'help-filling': '\ue87b',
  component: '\ue75f',
  'component-filling': '\ue760',
  color: '\ue761',
  'color-filling': '\ue7cd',
  'credit-level': '\ue735',
  'credit-level-filling': '\ue736',
  email: '\ue69f',
  'email-filing': '\ue72d',
  favorite: '\ue6a0',
  'favorite-filing': '\ue730',
  'account-filing': '\ue732',
  'one-page-filing': '\ue75a',
  'sound-filling': '\ue883',
};
// export default {
//   less: '\ue6a5',
//   'more_unfold': '\ue6a6',
//   back: '\ue697',
//   more: '\ue6a7',
//   add: '\ue6b9',
//   subtract: '\ue6fe',
//   close: '\ue69a',
//   cry: '\ue69c',
//   delete: '\ue69d',
//   help: '\ue6a3',
//   refresh: '\ue6aa',
//   search: '\ue6ac',
//   success: '\ue6b1',
//   warning: '\ue6b6',
//   wrong: '\ue6b7',
//   clock: '\ue6bb',
//   scanning: '\ue6ec',
//   filter: '\ue6f1',
//   map: '\ue715',
//   play: '\ue719'
// };



// WEBPACK FOOTER //
// ./packages/dof-icon/type.js